import { AxiosInstance, AxiosProxyConfig } from 'axios';

import { ActivitiesColumnsEnum } from '../../../../../admin/columns/activities-columns.enum';
import { axios } from '../../../../api/axios-instance';
import { activitiesEndpoints } from '../../../../constants';
import { LocaleEnum } from '../../../../enum/locale.enum';
import { DeleteItemsInput } from '../../../../types';
import { PaginationRequest } from '../../../../types/pagination-request';
import { SortRequest } from '../../../../types/sort-request';
import { IActivity } from '../../entities/activity';
import {
  ActivitiesResponse,
  ActivityResponse,
  CreateActivityInput,
  SortedActivities,
  UpdateActivityInput,
  UpdateActivityStatusInput,
} from '../../schemas/activity.schema';

class ActivitiesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (activity: CreateActivityInput): Promise<ActivityResponse> => {
    return this.#requestInstance.post(activitiesEndpoints.activities, activity);
  };

  getActivities = async (
    data?: PaginationRequest & SortRequest<ActivitiesColumnsEnum>
  ): Promise<ActivitiesResponse> => {
    return this.#requestInstance.get(activitiesEndpoints.activities, { params: data });
  };

  getActivitiesByCategoryId = async (
    data?: PaginationRequest & SortRequest<ActivitiesColumnsEnum>
  ): Promise<ActivitiesResponse> => {
    return this.#requestInstance.get(activitiesEndpoints.activitiesByCategoryId, {
      params: data,
    });
  };

  getSortedActivities = async (
    config: AxiosProxyConfig,
    locale: LocaleEnum,
    data: PaginationRequest & SortRequest<ActivitiesColumnsEnum>
  ): Promise<SortedActivities[]> => {
    return this.#requestInstance.get(`${activitiesEndpoints.sortedActivities}?locale=${locale}`, {
      ...config,
      params: data,
    });
  };

  deleteActivity = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(activitiesEndpoints.getActivityById(id));
  };

  getActivityById = async (id: number): Promise<ActivityResponse> => {
    return this.#requestInstance.get(activitiesEndpoints.getActivityById(id));
  };

  updateActivity = async (input: UpdateActivityInput): Promise<IActivity> => {
    return this.#requestInstance.patch(activitiesEndpoints.getActivityById(input?.id), input);
  };

  updateActivityStatus = async (input: UpdateActivityStatusInput): Promise<IActivity> => {
    return this.#requestInstance.patch(activitiesEndpoints.getActivityStatusById(input?.id), input);
  };

  deleteMany = async (ids: DeleteItemsInput): Promise<void> => {
    return this.#requestInstance.delete(activitiesEndpoints.activities, { data: ids });
  };
}

export const activitiesApi = new ActivitiesApi(axios);
